import Bloomreach from './lib/Bloomreach';

export default Bloomreach;
